"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Возвращает отформатированное число в соответствии с культурой пользователя
 * @param {Intl.NumberFormatOptions=} config
 * @return {(value: number) => string}
 */
function numberFormat(config) {
    var format = new Intl.NumberFormat('ru-RU', __assign({ minimumFractionDigits: 0, maximumFractionDigits: 2 }, config));
    return format.format;
}
exports.default = numberFormat;
